export class PrivateEndpointServiceApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
  ) {
    super(message);
    this.name = 'PrivateEndpointServiceApiError';
  }
}
